import type { ActionReducerMap } from '@ngrx/store';
import {
  COMPANY_ACCOUNT_STORE_KEY,
  reducer as companyAccountReducer,
  type CompanyAccountState,
} from './company-account.reducer';
import {
  TAGS_STORE_KEY,
  reducer as tagsReducer,
  type TagsState,
} from './tags.reducer';

export interface SharedState {
  [COMPANY_ACCOUNT_STORE_KEY]: CompanyAccountState;
  [TAGS_STORE_KEY]: TagsState;
}

export const reducers: ActionReducerMap<SharedState> = {
  [COMPANY_ACCOUNT_STORE_KEY]: companyAccountReducer,
  [TAGS_STORE_KEY]: tagsReducer,
};
